module.exports = __webpack_public_path__ + "img/finland.8869c07a.svg";